module.exports = __webpack_public_path__ + "img/rank_4.7b33857.png";